import styles from './DesignPage.module.css';

const ratings = [
  { key: 'again', label: 'Не вспомнил', interval: '1 мин' },
  { key: 'hard', label: 'С трудом', interval: '6 мин' },
  { key: 'good', label: 'Вспомнил', interval: '3 д' },
  { key: 'easy', label: 'Слишком легко', interval: '9 д' },
] as const;

const forecast = [9, 12, 7, 14, 11, 8, 13, 10, 6, 12, 9, 11, 14, 8];

function Phone({
  title,
  note,
  children,
}: {
  title: string;
  note: string;
  children: React.ReactNode;
}): React.JSX.Element {
  return (
    <figure className={styles.variant}>
      <div className={styles.phone}>{children}</div>
      <figcaption>
        <strong>{title}</strong>
        <span>{note}</span>
      </figcaption>
    </figure>
  );
}

function NavBar(): React.JSX.Element {
  return (
    <div className={styles.nav} aria-hidden="true">
      {['Сегодня', 'Учить', 'Колоды', 'Профиль'].map((tab, index) => (
        <span key={tab} className={index === 0 ? styles.navActive : ''}>
          {tab}
        </span>
      ))}
    </div>
  );
}

function HomePanel(): React.JSX.Element {
  return (
    <Phone
      title="A. Панель дня"
      note="Сейчас на проде. Бюджет полосой, одна главная кнопка, прогноз и плитки ниже."
    >
      <div className={styles.screen}>
        <h3 className={styles.h}>Сегодня</h3>
        <div className={styles.panel}>
          <b>6 из 15 мин сегодня</b>
          <div className={styles.meter}>
            <span style={{ width: '40%' }} />
          </div>
          <p>На повторение: 24, новых: 8. Примерно 7 мин.</p>
          <span className={styles.primary}>Начать</span>
        </div>
        <b className={styles.small}>Нагрузка на 30 дней</b>
        <div className={styles.bars}>
          {forecast.map((value, index) => (
            <span key={index} style={{ height: `${String(value * 4)}px` }} />
          ))}
        </div>
      </div>
      <NavBar />
    </Phone>
  );
}

function HomeRing(): React.JSX.Element {
  return (
    <Phone
      title="B. Кольцо"
      note="Одна цифра в центре — сколько минут осталось. Всё остальное мелко и ниже."
    >
      <div className={[styles.screen, styles.center].join(' ')}>
        <svg viewBox="0 0 120 120" className={styles.ring} aria-hidden="true">
          <circle cx="60" cy="60" r="50" className={styles.ringTrack} />
          <circle cx="60" cy="60" r="50" className={styles.ringFill} strokeDasharray="126 314" />
          <text x="60" y="58" textAnchor="middle" className={styles.ringValue}>
            9
          </text>
          <text x="60" y="76" textAnchor="middle" className={styles.ringLabel}>
            мин осталось
          </text>
        </svg>
        <span className={styles.primary}>Учить 32 карточки</span>
        <div className={styles.triple}>
          <span>
            <b>24</b>повторить
          </span>
          <span>
            <b>8</b>новых
          </span>
          <span>
            <b>91 %</b>вспоминаете
          </span>
        </div>
      </div>
      <NavBar />
    </Phone>
  );
}

function HomeList(): React.JSX.Element {
  return (
    <Phone
      title="C. Список колод"
      note="Плотно, как на GitHub: строка на колоду, у каждой своё «учить». Бюджет — одной строкой сверху."
    >
      <div className={styles.screen}>
        <p className={styles.budgetLine}>
          <b>Сегодня</b> · 6 из 15 мин · примерно 7 мин работы
        </p>
        {[
          ['Охрана труда', 18, 5],
          ['Английские слова', 6, 3],
          ['Электробезопасность', 0, 0],
        ].map(([title, due, fresh]) => (
          <div key={String(title)} className={styles.row}>
            <div>
              <b>{title}</b>
              <span className={styles.muted}>
                {String(due)} повторить · {String(fresh)} новых
              </span>
            </div>
            {Number(due) + Number(fresh) > 0 ? (
              <span className={styles.outline}>Учить</span>
            ) : (
              <span className={styles.muted}>готово</span>
            )}
          </div>
        ))}
        <span className={styles.primary}>Учить всё — 32</span>
      </div>
      <NavBar />
    </Phone>
  );
}

function ReviewGrid(): React.JSX.Element {
  return (
    <Phone
      title="A. Цветная сетка 2×2"
      note="Сейчас на проде. Четыре оценки под пальцем, интервал на каждой кнопке."
    >
      <div className={styles.review}>
        <div className={styles.card}>
          <p>Что такое СИЗ?</p>
          <hr />
          <p>Средства индивидуальной защиты</p>
        </div>
        <div className={styles.grid}>
          {ratings.map((rating) => (
            <span key={rating.key} className={[styles.rate, styles[rating.key]].join(' ')}>
              {rating.label}
              <small>{rating.interval}</small>
            </span>
          ))}
        </div>
      </div>
      <NavBar />
    </Phone>
  );
}

function ReviewRow(): React.JSX.Element {
  return (
    <Phone
      title="B. Спокойная строка"
      note="Нейтральные кнопки в один ряд, цвет только полоской. Меньше «светофора», больше места карточке."
    >
      <div className={styles.review}>
        <div className={[styles.card, styles.tall].join(' ')}>
          <p>Что такое СИЗ?</p>
          <hr />
          <p>Средства индивидуальной защиты</p>
        </div>
        <div className={styles.rowButtons}>
          {ratings.map((rating) => (
            <span
              key={rating.key}
              className={[styles.quiet, styles[`${rating.key}Edge`]].join(' ')}
            >
              {rating.label}
              <small>{rating.interval}</small>
            </span>
          ))}
        </div>
      </div>
      <NavBar />
    </Phone>
  );
}

function ReviewTwoStep(): React.JSX.Element {
  return (
    <Phone
      title="C. Два шага"
      note="Сначала честный вопрос «вспомнил или нет», уточнение «легко / с трудом» — необязательной строкой."
    >
      <div className={styles.review}>
        <div className={styles.card}>
          <p>Что такое СИЗ?</p>
          <hr />
          <p>Средства индивидуальной защиты</p>
        </div>
        <div className={styles.twoStep}>
          <span className={[styles.big, styles.again].join(' ')}>
            Не вспомнил<small>1 мин</small>
          </span>
          <span className={[styles.big, styles.good].join(' ')}>
            Вспомнил<small>3 д</small>
          </span>
        </div>
        <p className={styles.refine}>
          <span>С трудом · 6 мин</span>
          <span>Слишком легко · 9 д</span>
        </p>
      </div>
      <NavBar />
    </Phone>
  );
}

/**
 * Design options for the owner to choose from: three takes on the home screen
 * and three on the review screen, with made-up data. Not linked from the
 * application and not translated: it exists for one decision and goes away
 * once the chosen variants replace what is live.
 */
export function DesignPage(): React.JSX.Element {
  return (
    <div className={styles.page}>
      <h1>Варианты дизайна</h1>
      <p className={styles.muted}>
        Макеты на выдуманных данных. Выберите по одному варианту главной и экрана повторения —
        выбранный заменит текущий.
      </p>
      <h2>Главная, «Сегодня»</h2>
      <div className={styles.variants}>
        <HomePanel />
        <HomeRing />
        <HomeList />
      </div>
      <h2>Экран повторения</h2>
      <div className={styles.variants}>
        <ReviewGrid />
        <ReviewRow />
        <ReviewTwoStep />
      </div>
    </div>
  );
}
